export class FormulaFilter {
  yearId: number;
  reportTypeId: number;

  constructor(options?) {
    this.yearId = options ? options.yearId : null;
    this.reportTypeId = options ? options.reportTypeId : null;
  }
}
